import React from "react";
import clsx from "clsx";

import { useRacehorse360Api, useSetQueryData } from "hooks/api";
import ActionCellCheckbox from "components/VetExamsTable/TableRow/RowContent/ActionCellsWrapper/ActionCellCheckbox";
import {
  withClickBlocker,
  WithClickBlockerProps
} from "components/BlockableClickContext";
import { PRE_RACE_ENTRIES_TOTAL_RESULTS_QUERY_KEY } from "../../../options";

import useStyles from "./styles";

interface IProps {
  entryId: string;
  isExamChecked: boolean;
  isPassChecked: boolean;
  onSetIsExamChecked: (value: boolean) => void;
  onSetIsPassChecked: (value: boolean) => void;
}

const EntriesTabActionCells: React.FC<
  IProps & WithClickBlockerProps
> = props => {
  const {
    entryId,
    isPassChecked,
    isExamChecked,
    onSetIsExamChecked,
    onSetIsPassChecked,
    handleBlockableClick
  } = props;

  const classes = useStyles();
  const { filterUpcomingRaceEntries } = useSetQueryData();

  const { useRequireUpcomingRaceEntryExam, useQuickPassUpcomingRaceEntry } =
    useRacehorse360Api();

  const {
    mutateAsync: createUpcomingRaceEntryExam,
    isPending: isUpcomingRaceEntryExamCreating
  } = useRequireUpcomingRaceEntryExam();

  const {
    mutateAsync: quickPassUpcomingRaceEntry,
    isPending: isQuickPassUpcomingRaceEntryLoading
  } = useQuickPassUpcomingRaceEntry();

  const handleExamCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleBlockableClick(async () => {
      const checked = event.target.checked;

      onSetIsExamChecked(checked);
      checked && onSetIsPassChecked(false);

      const targetEntry = await createUpcomingRaceEntryExam({ id: entryId });

      if (targetEntry?.id) {
        filterUpcomingRaceEntries(
          [targetEntry.id],
          PRE_RACE_ENTRIES_TOTAL_RESULTS_QUERY_KEY
        );
      }
    });
  };

  const handlePassCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleBlockableClick(async () => {
      const checked = event.target.checked;

      onSetIsPassChecked(checked);
      checked && onSetIsExamChecked(false);

      const passedEntry = await quickPassUpcomingRaceEntry({ id: entryId });

      filterUpcomingRaceEntries(
        [passedEntry.id],
        PRE_RACE_ENTRIES_TOTAL_RESULTS_QUERY_KEY
      );
    });
  };

  return (
    <>
      <ActionCellCheckbox
        className={clsx({ [classes.examCheckboxChecked]: isExamChecked })}
        checked={isExamChecked}
        isLoading={isUpcomingRaceEntryExamCreating}
        onChange={handleExamCheckChange}
        dataTestId={"examCheckbox"}
      />
      <ActionCellCheckbox
        className={clsx({ [classes.passCheckboxChecked]: isPassChecked })}
        checked={isPassChecked}
        isLoading={isQuickPassUpcomingRaceEntryLoading}
        onChange={handlePassCheckChange}
        dataTestId={"quickPassCheckbox"}
      />
    </>
  );
};

export default withClickBlocker<IProps>(React.memo(EntriesTabActionCells));
